import { render, staticRenderFns } from "./StatisticList.component.vue?vue&type=template&id=4ba3efd1"
import script from "./StatisticList.component.vue?vue&type=script&lang=js"
export * from "./StatisticList.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports